import { Button, Flex } from "@chakra-ui/react";
import FileManagementIcon from "@root/assets/icons/filemanagement";
import PlusIcon from "@root/assets/icons/plusicon";
import { NormalText } from "@root/components/adminDashboard/style";
import { HeadingText } from "@root/components/common/text/HeadingText";
import { useTranslation } from "react-i18next";
export const Headers = ({
  title = "",
  subheading = "",
  onAdd,
  onDrawerOpen,
  action = true,
  showFileManagement = true,
}: any) => {
  const { t } = useTranslation("common");
  return (
    <Flex flexDirection="column">
      <Flex flexDirection="row" justifyContent="space-between">
        <HeadingText text={title} fontWeight="700" fontSize="26px" />
        <Flex flexDirection="row" justifyContent="flex-end" gap="2">
          {showFileManagement && onDrawerOpen && (
            <Button
              bg="white"
              width="fit-content"
              color="#40599B"
              height="fit-content"
              px="5"
              py="3"
              border="2px solid #40599B"
              onClick={onDrawerOpen}
              gap="2"
            >
              <FileManagementIcon />
              {t("admin.fileManagement")}
            </Button>
          )}
          {action && (
            <Button
              bg="#0E0E0E"
              width="fit-content"
              height="fit-content"
              px="5"
              py="3"
              borderRadius="8px"
              onClick={onAdd}
              gap="2"
            >
              <PlusIcon />
              Add New
            </Button>
          )}
        </Flex>

      </Flex>
      <NormalText text={subheading} />
    </Flex>
  );
};
